import { useContext, useState } from 'react';
import GreatDealsLabel from '@/FiltersMenu/GreatDeals/GreatDealsLabel';
import TagId from '~/constants/TagId';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';
import { isDefined } from '~/utilities/array';
import Checkbox from '../Checkbox';
import FilterDrawer from '../FilterDrawer';
import { CommonWrapper } from '../styles';
import type WithClassName from '../WithClassName';

function GreatDeals({ className }: WithClassName) {
  const [show, setShow] = useState(false);
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateListFilter, updateBooleanFilter } = useContext(
    AppliedFiltersContext
  );

  // TODO if experiment wins talk to platform about adding a tagId for EV Tax Credit to Ways to Save in baseline
  const isInExperiment = useCheckExperimentBucket(
    'srch-tile-redesign-2023',
    'experiment'
  );
  const { buckets } = facetData.tagIds ?? {};
  const EVTag = buckets?.find(({ key }) => key === '116');
  const { tagIds, isFreeDelivery } = facetData.waysToSave ?? {};
  const filterKey = 'ways-to-save';

  const alphabetizedFilters = [
    isFreeDelivery,
    ...(tagIds?.buckets ?? []),
    ...(isInExperiment ? [EVTag] : [])
  ].filter(isDefined);

  return (
    <FilterDrawer
      className={className}
      dataQa={`facet-${filterKey}`}
      facetContent={tagIds}
      facetName="Great Deals"
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <CommonWrapper>
        {alphabetizedFilters.map(({ count, displayName, key }) => {
          return key === 'isFreeDelivery' ? (
            <Checkbox
              key={key}
              checked={appliedFilters.isFreeDelivery ?? false}
              facet={filterKey}
              filter={key}
              id={`${filterKey}-isFreeDelivery`}
              label={
                <GreatDealsLabel
                  count={count}
                  displayName={displayName}
                  labelKey={key}
                />
              }
              onChange={() => {
                updateBooleanFilter({
                  filterKey: 'isFreeDelivery',
                  value: !appliedFilters?.isFreeDelivery
                });
              }}
              className="!items-start"
            />
          ) : (
            <Checkbox
              key={displayName}
              checked={appliedFilters?.tagIds?.includes(key)}
              id={`${filterKey}-${displayName}`}
              facet={filterKey}
              filter={key}
              label={
                <GreatDealsLabel
                  count={count}
                  displayName={
                    key === TagId.EVCredit.toString()
                      ? 'EV Tax Credit'
                      : displayName
                  }
                  labelKey={key}
                />
              }
              onChange={() =>
                updateListFilter({
                  filterKey: 'tagIds',
                  value: key
                })
              }
              className="!items-start"
            />
          );
        })}
      </CommonWrapper>
    </FilterDrawer>
  );
}

export default GreatDeals;
